export { ShowHero } from './ShowHero'
export type { ShowHeroProps } from './ShowHero'
